<script>
import { VTextField } from 'vuetify/lib'

export default {
  name: 'Input',
  props: {
    outlined: {
      type: Boolean,
      default: true,
    },
    hideDetails: {
      type: String,
      default: 'auto',
    },
    dense: {
      type: Boolean,
      default: true,
    },
  },
  extends: VTextField,
}
</script>